<template>
  <vs-chip class="ag-grid-cell-chip" :color="chipColor(params.value)">
    <span>{{ params.value }}</span>
  </vs-chip>
</template>

<script>
export default {
  name: 'CellRendererStatus',
  methods: {
    chipColor(value) {
      if (value === true) return 'success'
      else if (value === false) return 'danger'
      else 
      {
        const [amount, unit] = value.split(' ');
        if (unit === 'min') {
          return 'lightgreen'; // Utilisez un bleu très vif pour moins d'une heure
        } else if (unit === 'h') {
          const hour = parseInt(amount, 10);
          if (hour < 24) {
            return 'cornflowerblue'; // Bleu vif pour moins de 8 heures
          }
        }
        return ''; // Gris après 24 heures
      }
    }
  }
}
</script>
